<div class="popover-overlay" *ngIf="visible" (click)="close()">
  <div class="popover-content" (click)="$event.stopPropagation()">
    <div class="popover-header">
      <div class="popover-title popover-title-font">
        <img src="/assets/svg/bfd-company-icon.svg" alt="Icone Empresa" />
        <span>Empresa padrão</span>
      </div>
      <button class="close-btn" (click)="close()">&times;</button>
    </div>

    <div class="popover-body-emp">
      <div class="popover-body-emp-subtitulo">
        <p class="subtitulo">
          Defina uma empresa padrão para acesso ao Internet Banking do Banco Fibra.
        </p>
        <p class="description">
          Você pode definir a empresa padrão para que em todas as vezes que entrar no Internet Banking ou aplicativo você já acesse as informações da empresa escolhida.
        </p>
      </div>

      <app-radio-group [options]="data" (selectionChange)="onCompanySelected($event)"></app-radio-group>

      
      <div class="popover-footer">
        <label *ngIf="!flagShowCheckbox" class="checkbox-container">
          <input type="checkbox" [(ngModel)]="selectedCheckBox">
          <span class="checkmark"></span>
          Não perguntar novamente
        </label>
        <div class="popover-button">
          <bfd-button
            [text]="'Confirmar'"
            [loading]="showLoader"
            [disabled]="!botaoHabilitado"
            [type]="'primary-wide'"
            (buttonClick)="confirmSelection()"
          ></bfd-button>
        </div>
      </div>
      
    </div>
  </div>
</div>
